const modalContextActions = {
    cartDisplaying: false,
    setCartDisplaying: (displaying: boolean) => {},
}

export default modalContextActions